var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConsumerBan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 120,
    viewBox: "0 0 121 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.1903 25.7143C85.1903 37.9829 75.2446 47.9286 62.976 47.9286C50.7074 47.9286 40.7617 37.9829 40.7617 25.7143C40.7617 13.4457 50.7074 3.5 62.976 3.5C75.2446 3.5 85.1903 13.4457 85.1903 25.7143ZM88.6903 25.7143C88.6903 39.9159 77.1776 51.4286 62.976 51.4286C48.7744 51.4286 37.2617 39.9159 37.2617 25.7143C37.2617 11.5127 48.7744 0 62.976 0C77.1776 0 88.6903 11.5127 88.6903 25.7143ZM61.9036 60C82.9558 60 100.704 74.4981 106.165 94.2849H102.524C97.1721 76.4175 80.959 63.5 61.9036 63.5C42.8481 63.5 26.635 76.4175 21.283 94.2849H17.6426C23.1028 74.4981 40.8514 60 61.9036 60Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70 102H54C52.8954 102 52 102.895 52 104V113C52 114.105 52.8954 115 54 115H70C71.1046 115 72 114.105 72 113V104C72 102.895 71.1046 102 70 102Z",
    fill: "#00A3E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.5 81V88H57.5V81C57.5 78.2386 59.7386 76 62.5 76C65.2614 76 67.5 78.2386 67.5 81ZM54.5 88V81C54.5 76.5817 58.0817 73 62.5 73C66.9183 73 70.5 76.5817 70.5 81V88H75C76.1046 88 77 88.8954 77 90V114C77 115.105 76.1046 116 75 116H49C47.8954 116 47 115.105 47 114V90C47 88.8954 47.8954 88 49 88H54.5ZM70.5 91H67.5H57.5H54.5H50V113H74V91H70.5Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsumerBan);
export default __webpack_public_path__ + "static/media/consumer-ban.0a6ac9655bfe559f2641555a733f0dcc.svg";
export { ForwardRef as ReactComponent };